import { findIndex, set } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import './stockFiltering.scss';
import { Button, Col, Container, Row, Modal } from 'react-bootstrap';
import DropdownPicker from '../../components/pickers/dropdownPicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { Accordion, AccordionTab } from 'primereact/accordion';
import DataTableComponent from '../../components/dataTables/dataTable';
import { Toast } from 'primereact/toast';
import AddCriteriaModal from './components/ratio-modal/addCriteriaModal';
import { DashboardServiceApi, QueryServiceApi } from "../../services/stockFiltering/api";
import { Configuration } from "../../services/stockFiltering/configuration"
import { useSelector } from "react-redux";

import { DashboardServiceApi as WatchlistDashboardServiceApi } from "../../services/watchlist/api";
import { Configuration as WatchlistConfiguration } from "../../services/watchlist/configuration";

import { IndexServiceApi, PageName } from "../../services/actionHub/api";
import { Configuration as IndexServiceApiConfiguration } from "../../services/actionHub/configuration";
import lodash from 'lodash';
import ListBarStockFiltering from './components/listBarStockFiltering';
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from 'primereact/dropdown';
import { APIControl } from '../../helpers/APIControl';
import Spinner from '../../components/spinner';
import { useTranslation } from "react-i18next";
import { de } from 'date-fns/locale';
import { useHitTracking } from '../../context/hit-tracking-context';

const StockFiltering = () => {
    const { t, i18n } = useTranslation();
    const { trackInteraction } = useHitTracking();
    const actionHubIndexApi = new IndexServiceApi(new IndexServiceApiConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const dashboardServiceApi = new DashboardServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_FILTERING_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_FILTERING_API_BASE_PATH));
    const queryServiceApi = new QueryServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_FILTERING_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_FILTERING_API_BASE_PATH));
    const watchlistServiceApi = new WatchlistDashboardServiceApi(new WatchlistConfiguration({ basePath: process.env.REACT_APP_WATCHLIST_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_WATCHLIST_API_BASE_PATH));
    const api = new DashboardServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_FILTERING_API_BASE_PATH, }), undefined, APIControl(process.env.REACT_APP_STOCK_FILTERING_API_BASE_PATH));
    const token = useSelector((state) => state.auth?.token);
    const toast = useRef(null);
    const [companies, setCompanies] = useState([]);
    const [selectedCompaniesIndex, setSelectedCompaniesIndex] = useState(null);
    const [selectedWatchlist, setSelectedWatchlist] = useState(null);
    const [ratiosArray, setRatiosArray] = useState([]);
    const [columnsData, setColumnsData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [ratios, setRatios] = useState([]);
    const [indexList, setIndexList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState();
    const [watchlistsData, setWatchlistsData] = useState([]);
    const { list, recentAction } = useSelector(state => state.watchlist);
    const [selectedListItem, setSelectedListItem] = useState([]);
    const [selectedRatios, setSelectedRatios] = useState({});
    const [saveModalShow, setSaveModalShow] = useState(false);
    const [saveModalInputListName, setSaveModalInputListName] = useState('');
    const [updateListBarStockFiltering, setUpdateListBarStockFiltering] = useState(false);
    const [predefinedList, setPredefinedList] = useState();
    const [submitFlag, setSubmitFlag] = useState(false);
    const [saveModelFlag, setSaveModelFlag] = useState(false);
    const [customPredefinedList, setCustomPredefinedList] = useState(false);
    const [isFinancial, setIsFinancial] = useState(false);
    const [selectedCustomListItem, setSelectedCustomListItem] = useState(null);
    const [isDisabledSaveButton, setIsDisabledSaveButton] = useState(true);
    const [isLoadingTable, setIsLoadingTable] = useState(true);
    const excelHeaderMap = useMemo(() => {
        const lang = (i18n.language || '').toLowerCase();
        if (lang.startsWith('en')) {
            return { code: 'Security Code', name: 'Security Name' };
        }
        return { code: 'Hisse Kodu', name: 'Hisse Adı' };
    }, [i18n.language]);
    // const language = useSelector((state) => state.profile?.basicDetail?.languagecode);
    const language = i18n.language;
    const [isRatioPanelShow, setIsRatioPanelShow] = useState(null);
    const [listCount, setListCount] = useState(0);
    const [warningModalShow, setWarningModalShow] = useState(false);
    const [activeListId, setActiveListId] = useState(null);
    const [model, setModel] = useState({
        culture: language,
        fieldFilter: {
            items: []
        },
        scopeFilter: {
            constituentEntityId: undefined,
            watchlistId: undefined,
            sourceDataId: 101,
            currencyDataId: 1
        },
        showFinancial: true
    });

    const [saveModel, setSaveModel] = useState({
        "name": "string",
        "filters": []
    });

    const companiesComboData = [

        {
            id: 1,
            name: t('stockFiltering.financialCompanies'),
        },
        {
            id: 2,
            name: t('stockFiltering.nonFinancialCompanies'),
        },
    ];

    useEffect(() => {
        setCompanies(companiesComboData);
        setSelectedCompaniesIndex(companiesComboData[1]);
        // Initialize model with showFinancial: false to match default non-financial companies selection
        setModel(prevModel => ({
            ...prevModel,
            showFinancial: false
        }));
        getActionHubStockIndexData();
        getWatchlist();
        getScreenerCategoryFieldList();
    }, []);

    useEffect(() => {

        if (selectedCustomListItem) setIsRatioPanelShow(selectedCustomListItem.criteriaPanelShow);


    }, [selectedCustomListItem]);

    useEffect(() => {
        if (recentAction === 'remove') {
            fetchData();
        }
    }, [recentAction]);

    useEffect(() => {
        if (submitFlag) { // submitFlag değiştiğinde fetchData fonksiyonunu çağır   
            fetchData();
        }
    }, [submitFlag, model]); // model bağımlılığa dikkat edin

    useEffect(() => {
        if (customPredefinedList && selectedRatios) {
            updateModelWithRatios();
            setCustomPredefinedList(false);
        }
    }, [customPredefinedList, selectedRatios]);

    useEffect(() => {
        if (saveModelFlag) {
            dashboardNew();
            setSaveModelFlag(false);
        }

    }, [saveModelFlag]);

    //#region Click Category Titles CUSTOM LIST
    const selectedListBarItem = (item) => {
        console.log('selectedListBarItem: ', item);
        trackInteraction(`listBar/${item.name || item.id}`);
        setActiveListId(item.id);
        let _predefinedList = lodash.map(item.filters, item => ({
            'id': item.screenerId,
            'name': item.scrennerName ? item.scrennerName : item.screenerId,
            'checked': true,

        }))
        setPredefinedList(_predefinedList);
        generateRatiosCustomList(item.filters);
        setSelectedCustomListItem(item);

        if (item.system)
            setIsDisabledSaveButton(true);
        else
            setIsDisabledSaveButton(false);

    }

    const generateRatiosCustomList = (selectedCriteria) => {
        console.log('generateRatiosCustomList selectedCriteria: ', selectedCriteria);

        const newRatiosArray = selectedCriteria.map(criteria => ({
            id: criteria.screenerId,
            name: criteria.scrennerName,
            comboData: [
                { id: 1, type: 'all', name: t('stockFiltering.all'), parentId: criteria.screenerId, all: 0, selected: !!criteria.empty },
                { id: 2, type: 'gte', name: t('stockFiltering.gte'), parentId: criteria.screenerId, gte: criteria.gte ? criteria.gte.value : 0, selected: !!criteria.gte },
                { id: 3, type: 'lte', name: t('stockFiltering.lte'), parentId: criteria.screenerId, lte: criteria.lte ? criteria.lte.value : 0, selected: !!criteria.lte },
                { id: 4, type: 'between', name: t('stockFiltering.between'), parentId: criteria.screenerId, gte: criteria.between ? criteria.between.gte.value : 0, lte: criteria.between ? criteria.between.lte.value : 0, selected: !!criteria.between }
            ],
        }));

        const newSelectedRatios = {};
        const newSelectedListItem = {};

        // Iterate over selectedCriteria in reverse to ensure the last occurrence of a screenerId takes precedence
        [...selectedCriteria].reverse().forEach(criteria => {
            if (!newSelectedListItem[criteria.screenerId]) {
                if (criteria.empty) {
                    newSelectedListItem[criteria.screenerId] = 1;
                    newSelectedRatios[criteria.screenerId] = { id: 1, type: 'all', name: t('stockFiltering.all'), parentId: criteria.screenerId, all: 0, selected: true };
                } else if (criteria.gte) {
                    newSelectedListItem[criteria.screenerId] = 2;
                    newSelectedRatios[criteria.screenerId] = { id: 2, type: 'gte', name: t('stockFiltering.gte'), parentId: criteria.screenerId, gte: criteria.gte.value, selected: true };
                } else if (criteria.lte) {
                    newSelectedListItem[criteria.screenerId] = 3;
                    newSelectedRatios[criteria.screenerId] = { id: 3, type: 'lte', name: t('stockFiltering.lte'), parentId: criteria.screenerId, lte: criteria.lte.value, selected: true };
                } else if (criteria.between) {
                    newSelectedListItem[criteria.screenerId] = 4;
                    newSelectedRatios[criteria.screenerId] = { id: 4, type: 'between', name: t('stockFiltering.between'), parentId: criteria.screenerId, gte: criteria.between.gte.value, lte: criteria.between.lte.value, selected: true };
                }
            }
        });

        setRatiosArray(newRatiosArray);
        setSelectedListItem(newSelectedListItem);
        setSelectedRatios(newSelectedRatios);

        setCustomPredefinedList(true);
    };


    //#endregion Click Category Titles CUSTOM LIST

    //#region Dropdown Picker

    const onCompaniesListChange = (e) => {

        // console.log('onCompaniesListChange', e);
        // setSelectedIndex(e.value);
        trackInteraction(`dropdown/companies/${e.name || e.id}`);
        let index = findIndex(companies, { id: e.id });
        setSelectedCompaniesIndex(companies[index]);
        const isFinancialValue = e.id === 1 ? true : false;
        setIsFinancial(isFinancialValue);
        
        // Update the model's showFinancial property to match the selected company type
        setModel(prevModel => ({
            ...prevModel,
            showFinancial: isFinancialValue
        }));
    }

    const onIndexListChange = (e) => {
        // console.log('onIndexChange', e);
        // setSelectedIndex(e.value);
        if (e) trackInteraction(`dropdown/index/${e.name || e.code}`);
        if (!e) {

            setSelectedWatchlist(watchlistsData[0]);
            setSelectedIndex(undefined);

            setModel(prevModel => ({
                ...prevModel,
                scopeFilter: {
                    sourceDataId: prevModel.scopeFilter.sourceDataId,
                    currencyDataId: prevModel.scopeFilter.currencyDataId,
                    watchlistId: watchlistsData[0].id
                }
            }));



            return;
        }

        let index = findIndex(indexList, { entityId: e.entityId });
        if (index !== -1) {

            setModel(prevModel => ({
                ...prevModel,
                scopeFilter: {
                    ...prevModel.scopeFilter,
                    constituentEntityId: indexList[index].entityId
                }
            }));
            setSelectedIndex(indexList[index]);

        }
        else {
            setModel(prevModel => ({
                ...prevModel,
                scopeFilter: {
                    ...prevModel.scopeFilter,
                    constituentEntityId: indexList[0].entityId
                }
            }));

            setSelectedIndex(indexList[0]);

        }

        setModel(prevModel => ({
            ...prevModel,
            scopeFilter: {
                ...prevModel.scopeFilter,
                watchlistId: undefined
            }
        }));

        setSelectedWatchlist(undefined);
    }

    // Dropdown seçimini işleyen fonksiyon
    const onRatioSpecChange = (item, e) => {

        // setSelectedListItem(e.value);
        item.comboData.forEach(data => {
            data.selected = false;
            if (data.id === e.value.id) {
                setSelectedListItem({ ...selectedListItem, [item.id]: data.id });
            }
        });

        setSelectedRatios({ ...selectedRatios, [item.id]: e.value });

        e.value.selected = true;

    };

    const onWatchListChange = (e) => {
        // console.log('onWatchListChange', e);
        // setSelectedIndex(e.value);
        if (e) trackInteraction(`dropdown/watchlist/${e.name || e.id}`);
        if (!e) {

            setSelectedWatchlist(undefined);
            setSelectedIndex(indexList[0]);

            setModel(prevModel => ({
                ...prevModel,
                scopeFilter: {
                    sourceDataId: prevModel.scopeFilter.sourceDataId,
                    currencyDataId: prevModel.scopeFilter.currencyDataId,
                    constituentEntityId: indexList[0].entityId
                }
            }));


            return;
        }

        let index = findIndex(watchlistsData, { id: e.id });
        if (index !== -1) {
            setSelectedWatchlist(watchlistsData[index]);

            setModel(prevModel => ({
                ...prevModel,
                scopeFilter: {
                    ...prevModel.scopeFilter,
                    watchlistId: watchlistsData[index].id
                }
            }));

        }
        else {
            setSelectedWatchlist(watchlistsData[0]);
            setModel(prevModel => ({
                ...prevModel,
                scopeFilter: {
                    ...prevModel.scopeFilter,
                    watchlistId: watchlistsData[0].id
                }
            }));

        }

        setModel(prevModel => ({
            ...prevModel,
            scopeFilter: {
                ...prevModel.scopeFilter,
                constituentEntityId: undefined
            }
        }));

        setSelectedIndex(undefined);
    }

    // InputNumber değeri değiştiğinde çağrılacak fonksiyon
    const handleValueChange = (value, parentId, key) => {
        // ratiosArray içinde ilgili parentId ve key'e sahip öğeyi bul ve güncelle
        const updatedRatiosArray = ratiosArray.map(ratio => {
            if (ratio.id === parentId) {
                return {
                    ...ratio,
                    comboData: ratio.comboData.map(data => {
                        if (data.type === selectedRatios[parentId].type) {
                            return { ...data, [key]: value };
                        }
                        return data;
                    }),
                };
            }

            return ratio;
        });
        setRatiosArray(updatedRatiosArray);
        console.log('updatedRatiosArray: ', updatedRatiosArray);

        setSelectedRatios({ ...selectedRatios, 'id': value });

        console.log('updatedRatiosArray: ', updatedRatiosArray);
    };

    //#endregion Dropdown Picker

    //#region Excel Export
    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(tableData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, 'Hisse_Filtreleme');
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };
    //#endregion Excel Export

    //#region Add Criteria Modal

    const checkedRatiosItem = (selectedCriteria) => {

        console.log('checkedRatiosItem selectedCriteria: ', selectedCriteria);
        // setSelectedCriteria(selectedCriteria);
        generateRatios(selectedCriteria);
    }

    const generateRatios = (selectedCriteria) => {
        setRatiosArray(prevRatios => {
            const newRatios = selectedCriteria.map(criteria => ({
                id: criteria.id,
                name: criteria.name,
                comboData: [
                    { id: 1, type: 'all', name: t('stockFiltering.all'), parentId: criteria.id, all: 0, selected: true },
                    { id: 2, type: 'gte', name: t('stockFiltering.gte'), parentId: criteria.id, gte: 0, selected: false },
                    { id: 3, type: 'lte', name: t('stockFiltering.lte'), parentId: criteria.id, lte: 0, selected: false },
                    { id: 4, type: 'between', name: t('stockFiltering.between'), parentId: criteria.id, gte: 0, lte: 0, selected: false }
                ]
            }));

            // ComboData'da yapılan değişiklikleri korumak için güncelleme
            const updatedRatios = newRatios.map(newRatio => {
                const existingRatio = prevRatios?.find(r => r.id === newRatio.id);
                return existingRatio ? {
                    ...newRatio,
                    comboData: newRatio.comboData.map(newData => {
                        const existingData = existingRatio.comboData.find(d => d.id === newData.id);
                        return existingData ? { ...newData, ...existingData } : newData;
                    })
                } : newRatio;
            });

            // setSelectedListItem fonksiyonunu kullanarak seçimleri güncelle
            setSelectedListItem(prevSelected => {
                const newSelected = { ...prevSelected };
                selectedCriteria.forEach(criteria => {
                    if (!Object.prototype.hasOwnProperty.call(newSelected, criteria.id)) {
                        newSelected[criteria.id] = 1; // Yeni eklenenler için "Tümünü Göster" seçeneği
                    }
                });
                return newSelected;
            });

            console.log('setRatiosArray updatedRatios: ', updatedRatios);
            return updatedRatios;
        });
    };
    //#endregion Add Criteria Modal

    //#region  Save Modal

    const handleSaveModalInputChange = (e) => {
        setSaveModalInputListName(e.target.value);
    }

    //#endregion Save Modal

    //#region Apply Ratios

    const applyRatios = () => {
        trackInteraction('button/apply');
        updateModelWithRatios();
    }

    //#region API CALLS 

    //#region ACTION HUB STOCK INDEX EFFECT

    const getActionHubStockIndexData = () => {
        actionHubIndexApi.actionhubCustomindexesGet(token, PageName.StockFiltering).then((res) => {
            const indexListData = lodash.map(res.data.indexes, (item) => ({
                name: item.name.trTr || item.name.enUs || '', // Öncelikli olarak trTr'yi, sonra enUs'u kullan
                code: item.code,
                entityId: item.entityId,
            }));
            setIndexList(indexListData);
            if (indexListData.length > 0) {
                const index = lodash.findIndex(indexListData, { entityId: 'sec.101.409' }); // BIST 100
                if (index !== -1) {
                    setSelectedIndex(indexListData[index]);
                    setModel(prevModel => ({
                        ...prevModel,
                        scopeFilter: {
                            ...prevModel.scopeFilter,
                            constituentEntityId: indexListData[index].entityId
                        }
                    }));
                } else {
                    setSelectedIndex(indexListData[0]);
                    setModel(prevModel => ({
                        ...prevModel,
                        scopeFilter: {
                            ...prevModel.scopeFilter,
                            constituentEntityId: indexListData[0].entityId
                        }
                    }));
                }
            }
        }).catch((err) => {
            console.error('Error fetching index data:', err);
        });
    };




    //#endregion ACTION HUB STOCK INDEX EFFECT

    //#region WatchList List 

    const getWatchlist = () => {
        const culture = language;

        watchlistServiceApi.watchlistListGet(token, culture).then((res) => {
            const mappedWatchlistData = res.data.items
                .filter(item => item.id.indexOf('predefined') === -1)
                .map(item => ({
                    name: item.name,
                    id: item.id,
                    count: "-"
                }));



            setWatchlistsData(mappedWatchlistData);


        }).catch((err) => {
            // console.log(err);
        });
    }

    //#endregion WatchList List

    //#region Dashboard Screener Category Field List

    const getScreenerCategoryFieldList = () => {
        const culture = language;
        dashboardServiceApi.dashboardScreenerCategorylistGet(token, culture).then((res) => {
            setRatios(res.data.categories);
            console.log('getScreenerCategoryFieldList', res.data.categories);

            // setIsLoading(false);
            // setDashboardList(response.data);
            // HtmlCode: "8169794"
            // Name: "İndikatör"
            // ObjectId: "scc.10"
            // fields: Array(1)
        }).catch((error) => {
            // console.log('getScreenerCategoryFieldList', error);
            // setIsLoading(false);
        });
    }

    //#endregion Dashboard Screener Category Field List

    //#region Dashboard Sync

    const dashboardSync = () => {
        // setIsLoading(true);

        const dashboardSyncObj = {
            "Id": "1234",
            "filters": [
                {
                    "screenerId": 1,
                    "gte": {
                        "Value": 10
                    },
                    "lte": {
                        "Value": 10
                    },
                    "between": {
                        "gte": {
                            "Value": 10
                        },
                        "lte": {
                            "Value": 10
                        }
                    },
                    "empty": {}
                }
            ]
        }

        api.dashboardSnycPost(token, dashboardSyncObj).then((response) => {
            // console.log('dashboardRename', response);
            // setIsLoading(false);
            // setDashboardList(response.data);
        }).catch((error) => {
            // console.log('dashboardRename', error);
            // setIsLoading(false);
        });
    }
    //#endregion Dashboard Sync

    //#region FETCH DATA

    const updateModelWithRatios = () => {

        // Modeli güncelle
        const newItems = ratiosArray.flatMap(ratio => {
            return ratio.comboData.filter(data => data.selected).map(data => {
                const newItem = { screenerId: ratio.id };
                switch (data.type) {
                    case 'all':
                        newItem.empty = {};
                        break;
                    case 'gte':
                        newItem.gte = { value: data.gte };
                        break;
                    case 'lte':
                        newItem.lte = { value: data.lte };
                        break;
                    case 'between':
                        newItem.between = { gte: { value: data.gte }, lte: { value: data.lte } };
                        break;
                    default:
                        return null;
                }
                return newItem;
            }).filter(item => item !== null);
        });

        setModel(prevModel => ({
            ...prevModel,
            fieldFilter: {
                // items: [...prevModel.fieldFilter.items, ...newItems]
                items: newItems
            }
            // showFinancial property is preserved from the previous state
        }));
        setSubmitFlag(true); // Model güncellendikten sonra API çağrısını tetiklemek için yazdım. 

        // fetchData();
    };
    


    const fetchData = () => {
        setIsLoadingTable(true);

        if (selectedCustomListItem.criteriaPanelShow) {
            queryServiceApi.stockfilterFetchdataPost(token, model).then((res) => {
                let data = res.data;
                const processedData = data.Items.map(item => {
                    const newItem = {
                        code: item.code,
                        name: item.name,
                        entityId: `sec.${item.sourceId}.${item.securityId}`,
                    };
                    data.columns.forEach(col => {
                        const field = item.Fields.find(f => f.dataId === col.dataId);
                        newItem[col.name] = field ? field.value : null;
                    });
                    return newItem;
                });

                const processedColumns = [
                    { id: 1, field: 'searchableHeader', displayName: t('tableHeader.securityCode'), header: t('tableHeader.securityCode'), format: "code-f-t", isVisible: true, width: '10%', align: 'left', clikable: true },
                    { id: 2, field: 'name', displayName: t('tableHeader.securityName'), header: t('tableHeader.securityName'), isVisible: true, width: '10%', align: 'left', clikable: true, elipsisName: true },
                    ...data.columns
                        .sort((a, b) => a.order - b.order) // Sort by the 'order' field
                        .map((col, index) => ({
                            id: index + 3,
                            field: col.name,
                            displayName: col.name,
                            header: col.name,
                            isVisible: true,
                            width: '10%',
                            align: 'right',
                            sortable: true,
                        }))
                ];

                setColumnsData(processedData.length === 0 ? [] : processedColumns);

                setTableData(processedData);

                setTimeout(() => {
                    setIsLoadingTable(false);
                }, 750);
            }).catch((error) => {
                console.log('fetchData', error);
            });
        } else {
            queryServiceApi.stockfilterFetchformulatedataGet(token, model.culture, selectedCustomListItem.id, model.scopeFilter.constituentEntityId, model.scopeFilter.watchlistId, model.showFinancial  ).then((res) => {
                let data = res.data;
                const processedData = data.Items.map(item => {
                    const newItem = {
                        code: item.code,
                        name: item.name,
                        entityId: `sec.${item.sourceId}.${item.securityId}`,
                    };

                    data.columns.forEach(col => {
                        const field = item.Fields.find(f => f.dataId === col.dataId);
                        newItem[col.name] = field ? field.value : null;
                    });

                    return newItem;
                });

                const processedColumns = [
                    { id: 1, field: 'searchableHeader', displayName: t('tableHeader.securityCode'), header: t('tableHeader.securityCode'), format: "code-f-t", isVisible: true, width: '10%', align: 'left', clikable: true },
                    { id: 2, field: 'name', displayName: t('tableHeader.securityName'), header: t('tableHeader.securityName'), isVisible: true, width: '20%', align: 'left', clikable: true, elipsisName: true },
                    ...data.columns
                        .sort((a, b) => a.order - b.order) // Sort by the 'order' field
                        .map((col, index) => ({
                            id: index + 3,
                            field: col.name,
                            displayName: col.name,
                            header: col.name,
                            isVisible: true,
                            width: '10%',
                            align: 'right',
                            sortable: true,
                        }))
                ];

                setColumnsData(processedData.length === 0 ? [] : processedColumns);
                setTableData(processedData);

                setTimeout(() => {
                    setIsLoadingTable(false);
                }, 750);
            }).catch((error) => {
                console.log('fetchData', error);
            });
        }
    }


    //#endregion FETCH DATA

    //#region  Save List Dashboard New
    const beforeSaveList = () => {
        // setIsLoading(true);
        if (ratiosArray.length === 0) {
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('stockFiltering.selectedCriteria') });
            return;
        }
        // else if()

        trackInteraction('button/saveAs');
        setSaveModalShow(true);
    }

    const saveList = () => {
        // setIsLoading(true);

        if (listCount < 7)
            saveModelWithRatios();
        else {
            setSaveModalShow(false);
            setWarningModalShow(true);
        }
    }

    const saveModelWithRatios = () => {

        console.log('saveModelWithRatios');
        if (ratiosArray.length === 0) {
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('stockFiltering.selectedCriteria') });
            return;
        }

        // Yeni filtreler oluştur
        let newFilters = [];
        ratiosArray.forEach((ratio) => {
            ratio.comboData.forEach((data) => {
                if (data.selected) {
                    const filter = { screenerId: ratio.id, scrennerName: ratio.name };
                    if (data.type === 'all') {
                        filter.empty = {};
                    } else if (data.type === 'gte') {
                        filter.gte = { value: data.gte };
                    } else if (data.type === 'lte') {
                        filter.lte = { value: data.lte };
                    } else if (data.type === 'between') {
                        filter.between = {
                            gte: { value: data.gte },
                            lte: { value: data.lte }
                        };
                    }
                    newFilters.push(filter);
                }
            });
        });

        // saveModel güncelle
        setSaveModel(prevModel => ({
            ...prevModel,
            name: saveModalInputListName,
            filters: newFilters
        }));
        setSaveModelFlag(true);
        // Yeni modeli API'ye gönder
    };


    const dashboardNew = () => {
        dashboardServiceApi.dashboardNewPost(token, saveModel).then((res) => {
            // console.log('saveList', res);    
            // setIsLoading(false);
            // setDashboardList(response.data);
            toast.current.show({ severity: 'success', summary: t('successful'), detail: t('listSavedSuccessfully') });
            setSaveModalShow(false);
            setSaveModalInputListName('');
            setUpdateListBarStockFiltering(!updateListBarStockFiltering);

        }).catch((error) => {
            // console.log('saveList', error);
            // setIsLoading(false);
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('stockFiltering.listSaveError') });

        });
    }

    //#endregion  Save List Dashboard New

    //#endregion API CALLS 


    const accordionTabHeader = (item) => {
        return (
            <div className='d-flex flex-row justify-content-between '>
                <label className='roboto-bold-16 accordion-header-link'>
                    {/* {item.name.trTR || item.name.enUS || item.name} */}
                    {item.name[i18n.language.replace("-", "")]}
                    {/* {item.name} */}
                </label>

                <FontAwesomeIcon className='close-icon cursor' icon={faXmark} onClick={() => removeItemForRatioList(item)} />
            </div>
        );
    }


    const removeItemForRatioList = (item) => {
        let index = findIndex(ratiosArray, { id: item.id });
        let newRatiosArray = [...ratiosArray];
        newRatiosArray.splice(index, 1);
        setRatiosArray(newRatiosArray);
    }

    const saveHandler = () => {

        if (selectedCustomListItem.system) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: t('stockFiltering.systemListError') });
            return;
        }
        trackInteraction('button/save');

        let newFilters = [];
        ratiosArray.forEach((ratio) => {
            ratio.comboData.forEach((data) => {
                if (data.selected) {
                    const filter = { screenerId: ratio.id, scrennerName: ratio.name };
                    if (data.type === 'all') {
                        filter.empty = {};
                    } else if (data.type === 'gte') {
                        filter.gte = { value: data.gte };
                    } else if (data.type === 'lte') {
                        filter.lte = { value: data.lte };
                    } else if (data.type === 'between') {
                        filter.between = {
                            gte: { value: data.gte },
                            lte: { value: data.lte }
                        };
                    }
                    newFilters.push(filter);
                }
            });
        });

        let updateObj = {
            id: selectedCustomListItem.id,
            filters: newFilters
        }

        api.dashboardSnycPost(token, updateObj).then((res) => {
            console.log('dashboardRename', res);
            setUpdateListBarStockFiltering(true);
        }).catch((error) => {
            console.log('dashboardRename', error);
        });
    }

    return (
        <div className='stock-filtering-screen' >

            <Toast ref={toast} position='bottom-right' />

            {/* <h1>Stock Filtering</h1> */}

            {/* Category Titles Button */}
            <ListBarStockFiltering selectedListBarItem={selectedListBarItem} listUpdated={updateListBarStockFiltering} isFinancial={isFinancial} activeId={activeListId}  listCount={(val) => { setListCount(val) }} />
            {/* Category Titles Button */}

            {/* Dropdown Items */}
            <Container className='m-t-20' >
                <Row className=''>
                    <Col lg='3' className='dropdown-col-1 index-dropdown' >
                        <div data-testid="company-dropdown-trigger">
                            <DropdownPicker className='index-dropdown-trigger' listData={companies} selectedListItem={selectedCompaniesIndex} onListItemChange={onCompaniesListChange} icon={true} disabled={false} />
                        </div>
                    </Col>

                    <Col lg='3' className='dropdown-col-2'>
                        <div data-testid="index-dropdown-trigger">
                            <DropdownPicker listData={indexList} selectedListItem={selectedIndex} onListItemChange={onIndexListChange} icon={true} showClear={true} placeholder={t('stockFiltering.selectIndex')} />
                        </div>
                    </Col>

                    <Col lg='1' className='text-col m-t-auto m-b-auto'>
                        <label className='text  p-0'>
                            {t('or')}
                        </label>
                    </Col>

                    <Col lg='3' className='dropdown-col-3'>
                        <div data-testid="wathclist-dropdown-trigger">
                            <DropdownPicker className='' listData={watchlistsData} selectedListItem={selectedWatchlist} onListItemChange={onWatchListChange} placeholder={t('stockFiltering.selectWatchList')} icon={true} showClear={true} />
                        </div>
                    </Col>

                    <Col lg='2' className='excel-icon-col'>
                        {/* <FontAwesomeIcon className='excel-icon' icon={faFileExcel} onClick={exportExcel} /> */}
                    </Col>
                </Row>
            </Container >
            {/* Dropdown Items */}


            {/* Rasyolar - Tablo */}

            <Container className='ratios-table-container m-t-20'>
                <Row>
                    {/* Rasyolar */}
                    {
                        isRatioPanelShow && (
                            <Col lg='3' className='ratios-col' >
                                <div className='ratios-box'>
                                    {/* Header */}
                                    <Row className='ratios-header-row'>
                                        <Col>
                                            <label className=' ratios-text roboto-bold-16'>
                                                {t(('stockFiltering.rastios'))}
                                            </label>
                                        </Col>
                                        <Col className='add-criteria-col'>
                                            {/* <div>
                                        <FontAwesomeIcon className='add-criteria-icon' icon={faPlus} />
                                        <label className='p-l-5 roboto-medium-16 add-criteria-button '>
                                            Kriter Ekle
                                        </label>
                                    </div> */}
                                            <AddCriteriaModal data-testid="modal-trigger" ratiosList={ratios} checkedRatiosItem={checkedRatiosItem} predefinedList={predefinedList} />
                                        </Col>
                                    </Row>
                                    {/* Header */}
                                    {/* Acordion  */}
                                    <Accordion activeIndex={0} className='AccordionTab'>
                                        {
                                            ratiosArray.map((item) => (
                                                <AccordionTab header={() => accordionTabHeader(item)} key={item.id}>
                                                    <div data-testid="AccordionTab">
                                                        <Dropdown
                                                            value={item.comboData.find(data => data.selected)} // Ensure the selected filter is displayed
                                                            onChange={(e) => onRatioSpecChange(item, e)}
                                                            options={item.comboData}
                                                            optionLabel='name'
                                                            placeholder=""
                                                            className="dropdown w-full transition"
                                                        />

                                                        <Row>
                                                            <Col className='input-col'>
                                                                {selectedRatios[item.id] && ["gte", "lte", "between"].includes(selectedRatios[item.id].type) && (
                                                                    <div>
                                                                        {selectedRatios[item.id].type === 'gte' && (
                                                                            <InputNumber
                                                                                value={selectedRatios[item.id].gte}
                                                                                onChange={(e) => handleValueChange(e.value, item.id, 'gte')}
                                                                                style={{ width: '100%' }}
                                                                                placeholder={t('stockFiltering.gteInputInfo')}
                                                                            />
                                                                        )}
                                                                        {selectedRatios[item.id].type === 'lte' && (
                                                                            <InputNumber
                                                                                value={selectedRatios[item.id].lte}
                                                                                onChange={(e) => handleValueChange(e.value, item.id, 'lte')}
                                                                                style={{ width: '100%' }}
                                                                                placeholder={t('stockFiltering.lteInputInfo')}
                                                                            />
                                                                        )}
                                                                        {selectedRatios[item.id].type === 'between' && (
                                                                            <>
                                                                                <div className="between-row">
                                                                                    <div style={{ width: '50%' }}>
                                                                                        <InputNumber
                                                                                            className="between-input"
                                                                                            value={selectedRatios[item.id].gte}
                                                                                            onChange={(e) => handleValueChange(e.value, item.id, 'gte')}
                                                                                            placeholder={t('stockFiltering.smallValue')}

                                                                                        />
                                                                                    </div>
                                                                                    <div style={{ width: '50%' }}>
                                                                                        <InputNumber
                                                                                            className="between-input"
                                                                                            value={selectedRatios[item.id].lte}
                                                                                            onChange={(e) => handleValueChange(e.value, item.id, 'lte')}
                                                                                            placeholder={t('stockFiltering.greatValue')}

                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                            </>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </Col>
                                                        </Row>




                                                    </div>
                                                </AccordionTab>
                                            ))
                                        }
                                    </Accordion>
                                    {/* Acordion  */}

                                    {/* Footer */}
                                    <Row className='ratios-buttons-footer'>
                                        <Col lg="5" className=' m-auto'>

                                            <Button className="ratios-button save-as  roboto-medium-14" onClick={beforeSaveList}>
                                                {t('saveAs')}
                                            </Button>

                                        </Col>
                                        <Col className=' m-auto p-l-0 p-r-0'>
                                            <Button className="ratios-button save roboto-medium-14" onClick={saveHandler} disabled={isDisabledSaveButton}>
                                                {t('save')}
                                            </Button>


                                        </Col>
                                        <Col className=' m-auto'>
                                            <Button className="ratios-button apply roboto-medium-14" onClick={applyRatios} >
                                                {t('apply')}
                                            </Button>


                                        </Col>
                                    </Row>
                                    {/* Footer */}

                                </div>
                            </Col>
                        )
                    }
                    {/* Rasyolar */}


                    {/* Tablo */}
                    <Col lg={!isRatioPanelShow ? '12' : '9'} className={`stockfiltering-table ${!isRatioPanelShow ? 'p-0' : ''}`}>
                        {isLoadingTable && <Spinner height="600px" />}
                        {!isLoadingTable &&
                            <DataTableComponent
                                columnsProp={columnsData}
                                dataProp={tableData}
                                columnsSelect={false}
                                search={false}
                                excelExport={true}
                                excelExportName='Hisse Filtreleme'
                                excelExcludeFields={['entityId']}
                                excelHeaderMap={excelHeaderMap}
                                emptyMessage={t('dataTable.emptyData')}
                            />

                        }


                    </Col>
                    {/* Tablo */}


                </Row>
            </Container>



            {/* Rasyolar - Tablo */}

            <Modal dialogClassName="modal-create-list" show={saveModalShow} aria-labelledby="contained-modal-title-vcenter" animation={true} backdrop="static" keyboard={false} centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className="modal-header-wrap">
                            <h6 className="m-0">{t('createNewList')}</h6>
                            <div className="modal-header-close" onClick={() => setSaveModalShow(false)}>
                                <FontAwesomeIcon icon={faXmark} />
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <div className="form-group" data-testid="listName-input">
                                <input type="text" value={saveModalInputListName} onChange={handleSaveModalInputChange}
                                    className="form-control input" id="listName-input" placeholder={t('listName')} />
                            </div>
                        </Col>
                    </Row>
                    <Button onClick={saveList} className="modal-save-btn save-button">
                        {t('save')}
                    </Button>
                </Modal.Body>
            </Modal>


            <Modal dialogClassName="modal-create-list" show={warningModalShow} aria-labelledby="contained-modal-title-vcenter" animation={true} backdrop="static" keyboard={false} centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className="modal-header-wrap">
                            <h6 className="m-0">{t("stockFilteringWarn")}</h6>
                            <div className="modal-header-close" onClick={() => setWarningModalShow(false)}>
                                <FontAwesomeIcon icon={faXmark} />
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        {i18n.language === 'tr-TR' ? <Col className='text-center roboto-medium-16'>
                            En fazla 7 adet filtre oluşturabilirsiniz.<br />
                            Filtrelerinizi <span style={{ color: '#418079' }}>kalem ikonu </span><span className='edit-pencil'><FontAwesomeIcon className="icon" icon={faPencil} /></span>
                            aracılığı ile silebilirsiniz.
                        </Col>
                            :
                            <Col className='text-center roboto-medium-16'>
                                You can create up to 7 filters.<br />
                                Set your filters with the <span style={{ color: '#418079' }}>pencil icon </span><span className='edit-pencil'>
                                    <FontAwesomeIcon className="icon" icon={faPencil} />
                                </span> you can delete it via.
                            </Col>
                        }

                    </Row>
                    <Button onClick={() => setWarningModalShow(false)} className="modal-save-btn save-button">
                        {t("okBtn")}
                    </Button>
                </Modal.Body>
            </Modal>


        </div >
    );
}

export default StockFiltering;
